import { graphql, useStaticQuery } from "gatsby";

export type SiteMeta = {
	title: { lang: string, value: string }[],
	description: { lang: string, value: string }[],
	siteUrl: string,
	author: string,
};

export function useSiteMeta(): SiteMeta {
	const data = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					title { lang value }
					description { lang value }
					author
					siteUrl
				}
			}
		}
	`);
	
	return data.site.siteMetadata;
}
